/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Crisp_EnabledInputs */

const en_admin_settings_fields_crisp_enabled = /** @type {(inputs: Admin_Settings_Fields_Crisp_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable Crisp`)
};

const zh_admin_settings_fields_crisp_enabled = /** @type {(inputs: Admin_Settings_Fields_Crisp_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`启用 Crisp`)
};

/**
* | output |
* | --- |
* | "Enable Crisp" |
*
* @param {Admin_Settings_Fields_Crisp_EnabledInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_crisp_enabled = /** @type {((inputs?: Admin_Settings_Fields_Crisp_EnabledInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Crisp_EnabledInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_fields_crisp_enabled(inputs)
	return zh_admin_settings_fields_crisp_enabled(inputs)
});
export { admin_settings_fields_crisp_enabled as "admin.settings.fields.crisp_enabled" }